import template from './input-type.jade';
import items from '../../../enums/input-type';

export default angular
    .module('cian.addForm.commonInputType', ['cian.addForm.fieldTypeDropdown'])
    .directive('cianAfCommonInputType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = items;
        },
        controllerAs: 'inputType',
        template,
    }))
    .name;
